export const TERRAFORM_TASK_INPUT_PARAMETERS = [
  {
    ParameterKey: "Application",
    ParameterValue: "Elasticache env",
  },
  {
    ParameterKey: "Environment",
    ParameterValue: "test",
  },
  {
    ParameterKey: "Environment_Name",
    ParameterValue: "PRD",
  },
  {
    ParameterKey: "PR_DataBucket_1",
    ParameterValue: "prdatabucket1",
  },
  {
    ParameterKey: "PR_DataBucket_2",
    ParameterValue: "prdatabucket2",
  },
  {
    ParameterKey: "PR_DataBucket_3",
    ParameterValue: "prdatabucket3",
  },
  {
    ParameterKey: "public_key",
    ParameterValue: "ssh-rsa AAAAB3NzaC1yc2EAAAADAQABAAAA...",
  },
  {
    ParameterKey: "instance_type",
    ParameterValue: "t3.2xlarge",
  },
  {
    ParameterKey: "vpc_id",
    ParameterValue: "vpc-096420827398e34dc",
  },
  {
    ParameterKey: "cidrblock",
    ParameterValue: "0.0.0.0/0",
  },
  {
    ParameterKey: "ELS_Cluster_Instance_Type",
    ParameterValue: "t2.small.elasticsearch",
  },
  {
    ParameterKey: "ELS_Cluster_Instance_Count",
    ParameterValue: "1",
  },
  {
    ParameterKey: "ELS_EBS",
    ParameterValue: "true",
  },
  {
    ParameterKey: "ELS_Volume_Size",
    ParameterValue: "20",
  },
  {
    ParameterKey: "ELS_Snapshot_Start_Time",
    ParameterValue: "23",
  },
  {
    ParameterKey: "ELS_Version",
    ParameterValue: "7.1",
  },
  {
    ParameterKey: "ELS_Domain_Name",
    ParameterValue: "els-proteinresearch-domain",
  },
  {
    ParameterKey: "ELS_Snapshot_Bucket",
    ParameterValue: "elsproteinresearchsnapshotbucket",
  },
  {
    ParameterKey: "PR_RDS_Storage",
    ParameterValue: "20",
  },
  {
    ParameterKey: "PR_RDS_Engine",
    ParameterValue: "mysql",
  },
  {
    ParameterKey: "PR_RDS_Engine_Version",
    ParameterValue: "5.7",
  },
  {
    ParameterKey: "PR_RDS_Instance_Class",
    ParameterValue: "db.t2.micro",
  },
  {
    ParameterKey: "PR_RDS_Name",
    ParameterValue: "ProteinResearch-Enricher-DB",
  },
  {
    ParameterKey: "PR_RDS_UserName",
    ParameterValue: "masteradmin",
  },
  {
    ParameterKey: "PR_RDS_Password",
    ParameterValue: "F0X99Pr0teIn",
  },
  {
    ParameterKey: "PR_RDS_PG",
    ParameterValue: "default.mysql5.7",
  },
  {
    ParameterKey: "PR_LambdaRuntime",
    ParameterValue: "python3.8",
  },
  {
    ParameterKey: "PR_LambdaArchitecture",
    ParameterValue: "x86_64",
  },
];

export const TERRAFORM_TASK_OUTPUT_PARAMETERS = [
  {
    Description: "Protien Research S3 Bucket 1 ARN",
    OutputKey: "S3 Bucket ARN 1",
    OutputValue: "arn:aws:s3:::prdatabucket1",
  },
  {
    Description: "Protien Research S3 Bucket 2 ARN",
    OutputKey: "S3 Bucket ARN 2",
    OutputValue: "arn:aws:s3:::prdatabucket2",
  },
  {
    Description: "Protien Research S3 Bucket 3 ARN",
    OutputKey: "S3 Bucket ARN 3",
    OutputValue: "arn:aws:s3:::prdatabucket3",
  },
  {
    Description: "Protien Research S3 Bucket 1 Name",
    OutputKey: "S3 Bucket Name 1",
    OutputValue: "prdatabucket1",
  },
  {
    Description: "Protien Research S3 Bucket 2 Name",
    OutputKey: "S3 Bucket Name 2",
    OutputValue: "prdatabucket2",
  },
  {
    Description: "Protien Research S3 Bucket 3 Name",
    OutputKey: "S3 Bucket Name 3",
    OutputValue: "prdatabucket3",
  },
];
